import { useCallback, useEffect, useMemo } from "react"

import { useBuilderContext } from "../context"

import useProp from "./useProp"

export default function useMetadata() {
  const form = useProp()

  return useMemo(() => ({
    form,
  }), [form])
}

export function useBuilderUpdateMetaForm({ value: formId }) {
  const { meta: { form: { setValue } } } = useBuilderContext()

  useEffect(() => {
    setValue(formId)
  }, [formId, setValue])
}

export {
  useBuilderUpdateMetaForm as useLoadFormMetadata,
}

export function useFormMetaParams() {
  const { meta: { form: { value: formId } } } = useBuilderContext()

  return useCallback(searchParams => {
    if (formId) {
      const hashFormParam = btoa(`fid:${formId}:force`)
      searchParams.set('__testab_form', hashFormParam)
    }
  }, [formId])
}
